// avstemming-receivables-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avbk.assess.notAssessed': 'Sin evaluar',
  'avbk.assess.expectedPaid': 'OK: se espera el cobro',
  'avbk.paidAfterPeriod': 'Cobrada después de la fecha del período',
  'avbk.assess.remind': 'Enviar recordatorio de pago',
  'avbk.assess.toCollection': 'Enviar a cobro',
  'avbk.assess.paymentPlan': 'Existe un acuerdo de pago',
  'avbk.assess.matchPayment': 'Debe conciliarse con un cobro',
  'avbk.assess.disputed': 'En disputa',
  'avbk.assess.issueCreditNote': 'Debe emitirse una nota de crédito',
  'avbk.assess.partialLoss': 'Riesgo de pérdida parcial',
  'avbk.assess.fullLoss': 'Riesgo de pérdida total',
  'avbk.assess.writeDown': 'Se valora un deterioro',
  'avbk.assess.writeOff': 'Dar de baja por incobrable',
  'avbk.assess.awaitingClient': 'A la espera del cliente',
  'avbk.assess.awaitingDocs': 'A la espera de documentación',
  'avbk.followUpNext': 'Seguimiento en el próximo período',
  'avbk.risk.high': 'Alto',
  'avbk.risk.medium': 'Medio',
  'avbk.risk.low': 'Bajo',
  'avbk.risk.unknown': 'Desconocido',
  'avbk.quick.needsAssessment': 'Requiere evaluación',
  'avbk.quick.allOpen': 'Todas las abiertas',
  'avbk.quick.overdue': 'Vencidas',
  'avbk.quick.over90': 'Más de 90 días',
  'avbk.quick.negative': 'Saldos negativos',
  'avbk.quick.creditNotes': 'Notas de crédito',
  'avbk.possibleDuplicates': 'Posibles duplicados',
  'avbk.quick.collection': 'Cobro judicial',
  'avbk.lossRisk': 'Riesgo de pérdida',
  'avbk.quick.missingDoc': 'Falta documento',
  'avbk.assessedDone': 'Evaluado',
  'avbk.daysLabel.na': 'No aplica',
  'avbk.notOverdue': 'No vencida',
  'avbk.overdueBy': 'Vencida hace {days} días',
  'avbk.flags.none': 'Ninguno',
  'avbk.flags.more': '+{count} más',
  'avbk.page.noAccount': 'El área no tiene ninguna cuenta de conciliación en este período.',
  'avbk.nav.overview': 'Resumen',
  'avbk.nav.openItems': 'Partidas abiertas',
  'avbk.nav.customerRisk': 'Riesgo de clientes y de crédito',
  'avbk.nav.controls': 'Controles',
  'avbk.nav.conclusion': 'Conclusión',
  'avbk.nav.blocked': 'Bloqueado',
  'avbk.nav.ready': 'Listo',
  'avbk.areaLabel': 'Cuentas por cobrar',
  'avbk.page.title': 'Auxiliar de clientes y partidas abiertas',
  'avbk.page.resetFilters': 'Restablecer filtros',
  'avbk.page.customerFilter': 'Cliente: {name}',
  'avbk.page.showAllCustomers': 'Mostrar todos los clientes',
  'avbk.page.accountFilter': 'Cuenta de control: {account}',
  'avbk.page.showAllAccounts': 'Mostrar todas las cuentas de control',
  'avbk.page.ageFilter': 'Tramo de antigüedad: {bucket}',
  'avbk.page.showAllAges': 'Mostrar todos los tramos de antigüedad',
  'avbk.customer': 'Cliente',
  'avbk.page.docNo': 'N.º doc.',
  'avbk.type': 'Tipo',
  'avbk.invoiceDate': 'Fecha de factura',
  'avbk.dueShort': 'Vencimiento',
  'avbk.page.original': 'Original',
  'avbk.openAmount': 'Importe pendiente',
  'avbk.daysOverdue': 'Días de vencimiento',
  'avbk.collection': 'Cobro',
  'avbk.alert': 'Aviso',
  'avbk.assessment': 'Evaluación',
  'avbk.seeAssessment': 'Ver evaluación',
  'avbk.assess': 'Evaluar',
  'avbk.page.noMatch': 'Ninguna partida de cliente coincide con los filtros.',
  'avbk.page.noOpenItems': 'No hay partidas abiertas de clientes en este período. Si el cliente no tiene facturas pendientes, no hay auxiliar que conciliar.',
  'avbk.header.controlAccount': 'Cuenta de control {accounts}',
  'avbk.responsible': 'Responsable: {name}',
  'avbk.header.ledgerVsSubledger': '{area}: libro mayor frente a auxiliar',
  'avbk.header.noControlAccount': 'Sin cuenta de control en el área',
  'avbk.header.ledgerMatches': 'El libro mayor y el auxiliar coinciden',
  'avbk.header.ledgerDiverges': 'El libro mayor y el auxiliar no coinciden',
  'avbk.header.noSubledgerAccount': 'Sin cuenta de control con auxiliar',
  'avbk.header.itemsNeedAssessment': '{count} partidas del auxiliar requieren evaluación antes de poder enviar la conciliación a revisión.',
  'avbk.header.noItemsLeft': 'No quedan partidas del auxiliar por evaluar.',
  'avbk.balance.title': 'Conciliación automática de saldos',
  'avbk.balance.computedAt': 'El auxiliar se ha calculado a fecha de {date}',
  'avbk.balance.subsequent': 'Hechos posteriores comprobados hasta el {date} inclusive',
  'avbk.balance.booked': 'Saldo contabilizado, cuenta de control con auxiliar',
  'avbk.balance.sumOpen': 'Suma de partidas abiertas en el auxiliar de clientes',
  'avbk.difference': 'Diferencia',
  'avbk.balance.noSubledger': 'Ninguna de las cuentas del área es la cuenta de cuentas por cobrar contra la que la app contabiliza las ventas ({account}). Por tanto, no hay auxiliar con el que comparar el saldo y la diferencia debe explicarse en la propia cuenta.',
  'avbk.balance.mismatch': 'La cuenta de control no coincide con el auxiliar. La diferencia debe explicarse antes de poder conciliar el área; consulta las contabilizaciones directas más abajo.',
  'avbk.balance.openingBalance': 'Saldo del período anterior',
  'avbk.balance.change': 'Variación en el período',
  'avbk.balance.openInvoices': 'Facturas abiertas',
  'avbk.balance.openCreditNotes': 'Notas de crédito abiertas',
  'avbk.balance.totalItems': 'Total de partidas en el control',
  'avbk.balance.customersWithBalance': 'Clientes con saldo',
  'avbk.accounts.title': 'Cuentas de control',
  'avbk.accounts.empty': 'Ninguna cuenta de balance está vinculada a cuentas por cobrar en este período. Sin una cuenta de control no hay saldo contabilizado con el que comparar el auxiliar.',
  'avbk.accounts.controlAccount': 'Cuenta de control',
  'avbk.accounts.bookedBalance': 'Saldo contabilizado',
  'avbk.accounts.subledgerBalance': 'Saldo del auxiliar',
  'avbk.status': 'Estado',
  'avbk.noSubledger': 'Sin auxiliar',
  'avbk.accounts.deviation': 'Desviación',
  'avbk.matches': 'Coincide',
  'avbk.accounts.open': 'Abrir cuenta',
  'avbk.control.ledgerVsSubledger': 'Libro mayor frente a auxiliar',
  'avbk.control.ledgerVsSubledgerHint': 'Saldo contabilizado comparado con la suma de las partidas abiertas al cierre del período.',
  'avbk.control.old': 'Partidas antiguas de más de 90 días',
  'avbk.control.oldHint': 'Partidas abiertas vencidas hace más de 90 días.',
  'avbk.control.negative': 'Saldos de clientes negativos',
  'avbk.control.negativeHint': 'Partidas con un importe a favor del cliente.',
  'avbk.control.affected': '{count} partidas afectadas',
  'avbk.control.duplicatesHint': 'Mismo cliente, misma fecha de factura y mismo importe.',
  'avbk.control.collectionNotices': 'Avisos de cobro enviados',
  'avbk.control.collectionNoticesHint': 'Partidas para las que el cliente ha enviado un aviso de cobro desde Plumme.',
  'avbk.control.lossToAssess': 'Riesgo de pérdida por evaluar',
  'avbk.control.lossToAssessHint': 'Partidas vencidas hace más de 90 días o escaladas a un aviso de cobro. El deterioro lo decide el contable.',
  'avbk.control.missingDoc': 'Documento de factura ausente',
  'avbk.control.missingDocHint': 'Partidas sin documento de factura guardado.',
  'avbk.control.over30': 'Partidas vencidas hace más de 30 días',
  'avbk.control.over30Hint': 'Partidas abiertas vencidas hace entre 31 y 90 días.',
  'avbk.control.partPaid': 'Cobrada en parte, pero todavía abierta',
  'avbk.control.partPaidHint': 'Partidas con un cobro registrado que aun así siguen abiertas.',
  'avbk.control.unmatchedCredit': 'Notas de crédito sin compensar',
  'avbk.control.unmatchedCreditHint': 'Notas de crédito abiertas que pueden compensarse con facturas.',
  'avbk.control.creditAfter': 'Nota de crédito posterior a la fecha del período',
  'avbk.control.creditAfterHint': 'Nota de crédito emitida después de la fecha del período sobre una factura que estaba abierta. Puede ser una cuestión de periodificación o de valoración.',
  'avbk.control.paidAfterHint': 'Partidas abiertas a la fecha del período que se cobraron después; normalmente es evidencia favorable.',
  'avbk.control.directPosted': 'Contabilizado directamente en la cuenta de control',
  'avbk.control.directPostedHint': 'Líneas del libro mayor en las cuentas de control que no proceden de una factura ni de un cobro.',
  'avbk.overCreditLimit': 'Clientes por encima del límite de crédito',
  'avbk.control.overLimitHint': 'Clientes con un saldo abierto superior al límite de crédito de su ficha.',
  'avbk.control.title': 'Tarjeta de control',
  'avbk.control.summary': 'Controles automáticos ejecutados: {checks} de {checks} · Controles con hallazgos: {findings} · Partidas que requieren evaluación manual: {unassessed}',
  'avbk.control.hide': 'Ocultar',
  'avbk.control.showAll': 'Mostrar todos los controles automáticos',
  'avbk.control.activeFilter': 'Filtro activo: {label} · {count} partidas',
  'avbk.control.removeFilter': 'Quitar filtro',
  'avbk.control.creditNote': 'La factura {invoice} ({customer}) estaba abierta a fecha de {date}. La nota de crédito {credit} se emitió el {creditDate}; puede ser una cuestión de periodificación o de valoración. Plumme no decide automáticamente a qué período pertenece la nota de crédito.',
  'avbk.aging.title': 'Distribución por antigüedad (días de vencimiento)',
  'avbk.aging.empty': 'No hay partidas abiertas de clientes al cierre del período; nada que distribuir por antigüedad.',
  'avbk.aging.note': 'Calculada desde la fecha de vencimiento, no desde la fecha de factura.',
  'avbk.aging.age': 'Antigüedad',
  'avbk.aging.itemCount': 'Número de partidas',
  'avbk.aging.share': 'Proporción',
  'avbk.aging.sumOpen': 'Suma de partidas abiertas',
  'avbk.risk.concentrationTitle': 'Riesgo de clientes y de concentración',
  'avbk.risk.concentrationEmpty': 'Ningún cliente tiene saldo abierto al cierre del período. El riesgo de concentración se mide con las partidas abiertas, así que sin ellas no hay distribución que evaluar.',
  'avbk.risk.largestBalance': 'Mayor saldo de cliente',
  'avbk.risk.topFive': 'Los 5 principales clientes sobre el saldo total',
  'avbk.risk.topFiveHint': 'Qué parte del saldo abierto corresponde a los cinco clientes más grandes.',
  'avbk.risk.noLimitSet': 'Sin límite definido',
  'avbk.risk.noLimitHint': 'El límite de crédito se define en la ficha del cliente. Sin límite, no hay nada con lo que medir.',
  'avbk.risk.multipleOld': 'Clientes con varias partidas antiguas',
  'avbk.risk.multipleOldHint': 'Clientes con más de una partida vencida hace más de 90 días.',
  'avbk.risk.withNotice': 'Clientes con aviso de cobro',
  'avbk.risk.highRisk': 'Clientes de riesgo alto',
  'avbk.risk.totalOpen': 'Saldo abierto total',
  'avbk.risk.overdueBalance': 'Saldo vencido',
  'avbk.risk.oldest': 'Partida más antigua',
  'avbk.risk.creditLimit': 'Límite de crédito',
  'avbk.risk.utilised': 'Utilizado',
  'avbk.collectionStatus': 'Estado de cobro',
  'avbk.risk.risk': 'Riesgo',
  'avbk.risk.noLimitNote': 'Ningún cliente tiene límite de crédito en su ficha. Si se define allí, el saldo abierto se mide aquí frente a ese límite.',
  'avbk.loss.title': 'Riesgo de pérdida y valoración',
  'avbk.loss.intro': 'Plumme ha identificado asuntos que pueden indicar riesgo de pérdida. El contable debe hacer y documentar la evaluación profesional: el sistema no decide automáticamente el deterioro ni la baja por incobrable, y tampoco los contabiliza.',
  'avbk.loss.totalExposure': 'Saldo total con riesgo de pérdida',
  'avbk.loss.assessedAmount': 'Importe evaluado en riesgo de pérdida',
  'avbk.loss.notDone': 'Sin terminar',
  'avbk.loss.assessedAmountHint': 'La suma de lo que el propio despacho ha evaluado como en riesgo de pérdida, deteriorado o dado de baja por incobrable.',
  'avbk.loss.highRiskItems': 'Partidas de riesgo alto',
  'avbk.loss.none': 'No hay partidas con riesgo de pérdida en este período.',
  'avbk.loss.invoice': 'Factura',
  'avbk.loss.open': 'Pendiente',
  'avbk.loss.proposed': 'Propuesto',
  'avbk.daysCount': '{days} días',
  'avbk.direct.title': 'Contabilizaciones directas en la cuenta de control',
  'avbk.direct.empty': 'Ninguna línea del libro mayor en las cuentas de control procede de algo distinto de una factura o un cobro. El control se ha ejecutado y no encontró nada.',
  'avbk.direct.note': 'Contabilizado directamente en la cuenta de control sin factura ni cobro. Estas líneas no tienen partida en el auxiliar y a menudo explican la diferencia entre el libro mayor y el auxiliar.',
  'avbk.direct.date': 'Fecha',
  'avbk.direct.voucher': 'Justificante',
  'avbk.direct.account': 'Cuenta',
  'avbk.direct.text': 'Texto',
  'avbk.direct.amount': 'Importe',
  'avbk.direct.sum': 'Total contabilizado directamente',
  'avbk.checks.title': 'Controles automáticos',
  'avbk.checks.note': 'Los controles no marcan nada en la lista de comprobación profesional. Indican qué debería haber revisado quien la marca.',
  'avbk.checks.check': 'Control',
  'avbk.checks.run': 'Ejecución',
  'avbk.checks.result': 'Resultado',
  'avbk.checks.ran': 'Ejecutado',
  'avbk.checks.findingsCount': '{count} hallazgos',
  'avbk.checks.noFindings': 'Sin hallazgos',
  'avbk.derived.old': 'Se han evaluado todas las partidas antiguas relevantes',
  'avbk.derived.negative': 'Se han explicado los saldos de clientes negativos',
  'avbk.derived.duplicates': 'Se han evaluado los posibles duplicados',
  'avbk.derived.unmatchedCredit': 'Se han evaluado las notas de crédito sin compensar',
  'avbk.derived.partPaid': 'Se han investigado las partidas cobradas en parte',
  'avbk.derived.collection': 'Se han revisado los casos de cobro',
  'avbk.derived.lossRisk': 'Se han evaluado las partidas con riesgo de pérdida',
  'avbk.derived.creditAfter': 'Se han evaluado las notas de crédito posteriores a la fecha del período',
  'avbk.derived.missingDoc': 'Se han tratado las partidas sin documento de factura',
  'avbk.blocker.itemOne': '{count} partida del auxiliar requiere evaluación',
  'avbk.blocker.itemMany': '{count} partidas del auxiliar requieren evaluación',
  'avbk.blocker.diff': '{amount} de la diferencia con el auxiliar está sin explicar',
  'avbk.blocker.lossOne': '{count} partida con riesgo de pérdida no está evaluada',
  'avbk.blocker.lossMany': '{count} partidas con riesgo de pérdida no están evaluadas',
  'avbk.blocker.checkpointOne': 'Queda {count} punto de control',
  'avbk.blocker.checkpointMany': 'Quedan {count} puntos de control',
  'avbk.checklist.title': 'Lista de comprobación profesional',
  'avbk.checklist.titleReadOnly': 'Lista de comprobación profesional (del responsable de la ejecución, solo lectura)',
  'avbk.checklist.none': 'No hay puntos de control definidos para las cuentas por cobrar en este período.',
  'avbk.checklist.note': 'Los puntos se aplican a toda el área. Una marca se guarda en todas las cuentas de control del período.',
  'avbk.checklist.groupItems': 'Partidas que requieren tratamiento',
  'avbk.checklist.countOf': '{done} de {total}',
  'avbk.checklist.handledOf': '{done} de {total} tratadas',
  'avbk.checklist.notApplicable': 'No aplica en este período',
  'avbk.checklist.followsAssessments': 'Se deriva de las evaluaciones',
  'avbk.checklist.groupAssessments': 'Evaluaciones profesionales generales',
  'avbk.checklist.groupReady': 'Preparación para la revisión',
  'avbk.checklist.performedBy': 'Realizado por {name}',
  'avbk.checklist.doneOfTotal': '{done} de {total} puntos de control completados',
  'avbk.conclusion.title': 'Conclusión y aprobación',
  'avbk.conclusion.label': 'Conclusión',
  'avbk.conclusion.placeholder': '¿Qué muestra la revisión de las cuentas por cobrar de este período?',
  'avbk.savedAsReason': 'Se guarda como justificación del punto de control «{label}».',
  'avbk.conclusion.remainingRisk': 'Riesgo pendiente',
  'avbk.conclusion.nothingBlocking': 'No queda nada que impida enviar el área a revisión.',
  'avbk.followup.title': 'Seguimiento del próximo período',
  'avbk.followup.none': 'Ninguna evaluación está marcada para seguimiento en el próximo período.',
  'avbk.followup.badge': 'En seguimiento',
  'avbk.followup.noAction': 'Sin medidas anotadas',
  'avbk.followup.due': 'Plazo {date}',
  'avbk.followup.expectedPaid': 'Cobro previsto {date}',
  'avbk.followup.open': 'Abrir evaluación',
  'avbk.conclusion.send': 'Enviar el área a revisión',
  'avbk.conclusion.oneThingLeft': 'Queda una cosa pendiente antes de poder enviar el área.',
  'avbk.conclusion.thingsLeft': 'Quedan {count} cosas pendientes antes de poder enviar el área.',
  'avbk.drawer.reasonOverdue': 'La cuenta por cobrar lleva {days} días vencida',
  'avbk.drawer.reasonNotice': 'El cliente ha enviado un aviso de cobro',
  'avbk.drawer.reasonReminders': 'Se han enviado {count} recordatorios de pago',
  'avbk.drawer.reasonPaidAfter': '{amount} cobrados después de la fecha del período',
  'avbk.drawer.reasonDuplicate': 'Posible duplicado de {others}',
  'avbk.drawer.unknownOrgNo': 'N.º de organización desconocido',
  'avbk.close': 'Cerrar',
  'avbk.drawer.dueDate': 'Fecha de vencimiento',
  'avbk.drawer.originalAmount': 'Importe original',
  'avbk.drawer.openAtPeriodEnd': 'Pendiente al cierre del período',
  'avbk.drawer.paidInPeriod': 'Cobrado en el período',
  'avbk.drawer.settledAfterDate': 'Pendiente por {open} al cierre del período · cobrados {settled} el {date}; normalmente es evidencia favorable de que la cuenta por cobrar era real y cobrable.',
  'avbk.drawer.settledAfter': 'Pendiente por {open} al cierre del período · cobrados {settled}; normalmente es evidencia favorable de que la cuenta por cobrar era real y cobrable.',
  'avbk.drawer.creditedAfter': 'La nota de crédito {docNumber} por {amount} se emitió el {date}, después de la fecha del período. Si se refiere a ingresos anteriores a la fecha del período es una cuestión de criterio profesional; Plumme no la decide.',
  'avbk.drawer.duplicateNote': 'Mismo cliente, misma fecha de factura y mismo importe que {others}. Es una propuesta para revisar, no una conclusión.',
  'avbk.drawer.noDocument': 'La partida no tiene ningún documento de factura guardado en Plumme.',
  'avbk.drawer.basis': 'Base de la evaluación:',
  'avbk.drawer.expectedDate': 'Fecha de cobro prevista',
  'avbk.drawer.expectedAmount': 'Importe de cobro previsto',
  'avbk.drawer.probability': 'Probabilidad de cobro',
  'avbk.drawer.proposedWriteDown': 'Deterioro propuesto',
  'avbk.drawer.proposedWriteOff': 'Baja por incobrable propuesta',
  'avbk.drawer.amountsNote': 'Los importes son propuestas del despacho. Plumme no contabiliza ningún deterioro ni baja por incobrable con ellos; quedan junto a la cuenta por cobrar hasta que alguien los contabilice.',
  'avbk.drawer.rationaleRequired': 'Justificación (obligatoria)',
  'avbk.drawer.rationale': 'Justificación',
  'avbk.drawer.rationalePlaceholder': '¿Qué muestra la revisión de esta cuenta por cobrar?',
  'avbk.drawer.action': 'Medida',
  'avbk.drawer.actionPlaceholder': 'P. ej.: hacer seguimiento del estado del cobro',
  'avbk.drawer.followUpDue': 'Plazo de seguimiento',
  'avbk.drawer.docsOnAccount': 'Documentación en la cuenta de control',
  'avbk.drawer.needsComment': 'Esta evaluación requiere una justificación.',
  'avbk.drawer.save': 'Guardar evaluación',
  'avbk.drawer.requestDocs': 'Pedir documentación al cliente',
});
